import { Toaster } from "sonner";
import { useTheme } from "@web/lib/theme";

/**
 * Quiet toasts: bottom centre, no rich colours, short duration, and a close button on every one
 * (an undo toast shows for a few seconds; its window runs on for `u`). Hovering pauses the timer.
 */
export function Toasts() {
  const { resolved } = useTheme();
  return (
    <Toaster
      theme={resolved}
      position="bottom-center"
      duration={3500}
      visibleToasts={3}
      closeButton
      // Above the Dock on feed screens (it publishes --mm-dock-h) and the phone tab bar.
      offset={{ bottom: "calc(var(--mm-dock-h, 0px) + 24px)" }}
      mobileOffset={{ bottom: "calc(var(--mm-dock-h, 0px) + 72px)" }}
      style={
        {
          // sonner hangs the close button off the top-left corner; put it top-right.
          "--toast-close-button-start": "unset",
          "--toast-close-button-end": "0",
          "--toast-close-button-transform": "translate(35%, -35%)",
        } as React.CSSProperties
      }
      toastOptions={{
        style: {
          background: "var(--paper)",
          color: "var(--ink)",
          border: "1px solid var(--line)",
          fontFamily: "var(--font-sans)",
        },
        classNames: {
          closeButton: "!border-line-strong !bg-paper !text-ink-2 hover:!bg-sunk hover:!text-ink",
        },
      }}
    />
  );
}
